/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DynamicBrandingService } from '@boxx/dynamic-branding';
import { Chart, registerables } from 'chart.js';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-views-chart-widget',
  templateUrl: './views-chart-widget.component.html',
  styleUrls: ['./views-chart-widget.component.scss'],
})
export class ViewsChartWidgetComponent implements OnInit {
  @ViewChild('viewsChart', { static: false }) viewsChart;

  @Input() set stats(payload: IStatsProps) {
    this.myStats = payload;

    if (payload.total) {
      this.setChartTheme();
      this.createChart([this.stats.maps, this.stats.search]);
    }
  }

  get stats(): IStatsProps {
    return this.myStats;
  }

  chart: Chart | any;
  chartData: any = {
    responsive: false,
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  };

  private myStats: IStatsProps = {
    total: 0,
    search: 0,
    maps: 0
  };

  constructor(dBrandingService: DynamicBrandingService) {
    Chart.register(...registerables);

    dBrandingService.themeChange$.subscribe(() => {
      if (this.chart) {
        this.setChartTheme();
        this.createChart([this.myStats.search, this.myStats.maps]);
      }
    });
  }

  ngOnInit() {
    setTimeout(() => {
      try {
        this.chart = new Chart(this.viewsChart.nativeElement, {
          type: 'doughnut',
          data: this.chartData,
          options: {
            cutout: 50,
          },
        });

        // set values in order for: [client, prospect, not_specified]
        this.createChart([this.stats.maps, this.stats.search]);
      } catch (e) {
        console.error('-- ngOnInit chart.js error', e);
      }
    }, 800);
  }

  getPercent(num: number){
    // if(num === 1){
    //   return this.stats.chain;//(this.stats.chain/this.stats.total*100).toFixed();
    // }
    if(num === 2){
      return this.stats.search;//(this.stats.search/this.stats.total*100).toFixed();
    }
    else if(num === 3){
      return this.stats.maps;//(this.stats.maps/this.stats.total*100).toFixed();
    }
    return null;
  }

  private setChartTheme() {
    const secondaryColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-not-specified')
      .trim();
    const tertiaryColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-prospect-color')
      .trim();
    const mediumColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-client-color')
      .trim();

    this.chartData.datasets[0].backgroundColor = ['#cf9cc8', '#99d2ff'];//[mediumColor, tertiaryColor, secondaryColor];
  }

  private createChart(values: Array<number>) {
    try {
      if(this.chart.data){
        this.chart.data.datasets.forEach(dataset => {
          // set values in order for: [client, prospect, not_specified]
          dataset.data = values;
        });
  
        this.chart.update();
      }
    } catch (e) {
      //console.error('-- createChart error', e);
    }
  }
}

interface IStatsProps {
  total: number;
  maps: number;
  search: number;
}
